import React from 'react';
import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      icon: 'flaticon-customer-support',
      title: 'Open/Enclosed Vehicle Transport',
      description: 'Several options are available if you choose to move your vehicle to a new home or any destination across the USA'
    },
    {
      icon: 'flaticon-route',
      title: 'Door To Door Auto Transport',
      description: 'The system of transporting your vehicle from one part of the State to another, is mostly preferred when moving to a new location.'
    },
    {
      icon: 'flaticon-online-booking',
      title: 'Vintage & Classic Vehicle Transport',
      description: 'Classic and Vintage Vehicles are historical timepieces, marking the automobile chronicles'
    },
    {
      icon: 'flaticon-customer-support',
      title: '24/7 Support',
      description: "We're here for you 24/7, ensuring seamless service anytime you need. Day or night, count on us to keep your cargo moving!"
    }
  ];

  return (
    <section className="ftco-section services-section ftco-no-pt ftco-no-pb">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 heading-section text-center ftco-animate mb-5">
            <span className="subheading">Our Services</span>
            <h2 className="mb-2">Our Services</h2>
          </div>
        </div>
        <div className="row d-flex">
          {services.map((service, index) => (
            <div key={index} className="col-md-3 d-flex align-self-stretch ftco-animate">
            <div className="media block-6 services">
              <div className="media-body py-md-4">
                <div className="d-flex mb-3 align-items-center">
                  <div className="icon"><span className={service.icon}></span></div>
                  <h3 className="heading mb-0 pl-3">{service.title}</h3>
                </div>
                <p>{service.description}</p>
              </div>
            </div>
          </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;


